/**
 * 路由 Key 枚举（由路径手动维护的驼峰 key）
 */
export enum ROUTE_KEY {
  // 经营分析
  Analysis = 'analysis',
  AnalysisPerformanceStatistics = 'analysisPerformanceStatistics',
  AnalysisPerformanceStatisticsDetail = 'analysisPerformanceStatisticsDetail',
  AnalysisBusinessDataExport = 'analysisBusinessDataExport',
  AnalysisIncome = 'analysisIncome',
  AnalysisLeads = 'analysisLeads',
  AnalysisRenewal = 'analysisRenewal',
  AnalysisConsume = 'analysisConsume',
  AnalysisCourseAnalysis = 'analysisCourseAnalysis',
  AnalysisClassAnalysis = 'analysisClassAnalysis',
  AnalysisStaffPerformanceStatistics = 'analysisStaffPerformanceStatistics',

  // 经营助手
  BusinessAssistant = 'businessAssistant',
  BusinessAssistantCardAssistant = 'businessAssistantCardAssistant',
  BusinessAssistantOperatingReport = 'businessAssistantOperatingReport',
  BusinessAssistantOperatingReportDetail = 'businessAssistantOperatingReportDetail',

  // 线索中心
  ClueCenter = 'clueCenter',
  ClueCenterCluePending = 'clueCenterCluePending',
  ClueCenterClueDone = 'clueCenterClueDone',
  ClueCenterClueDoneId = 'clueCenterClueDoneId',
  ClueCenterClueAuto = 'clueCenterClueAuto',

  // 会员中心
  Member = 'member',
  MemberDashboard = 'memberDashboard',
  MemberSettings = 'memberSettings',
  MemberDetailId = 'memberDetailId',
  MemberCardManagement = 'memberCardManagement',
  MemberContractPreview = 'memberContractPreview',
  MemberOpenCardRecord = 'memberOpenCardRecord',
  MemberFeedback = 'memberFeedback',

  // 课程管理
  CourseManagement = 'courseManagement',
  CourseManagementSchedule = 'courseManagementSchedule',
  CourseManagementCourseDetailId = 'courseManagementCourseDetailId',
  CourseManagementCancelledCourse = 'courseManagementCancelledCourse',
  CourseManagementCourseSettings = 'courseManagementCourseSettings',
  CourseManagementCourseType = 'courseManagementCourseType',
  CourseManagementDanceStyle = 'courseManagementDanceStyle',

  // 线上课
  OnlineCourse = 'onlineCourse',
  OnlineCourseCourseList = 'onlineCourseCourseList',
  OnlineCourseCourseDetailId = 'onlineCourseCourseDetailId',
  OnlineCourseCouponList = 'onlineCourseCouponList',
  OnlineCourseCouponDetailId = 'onlineCourseCouponDetailId',
  OnlineCourseOnlineCourseIncome = 'onlineCourseOnlineCourseIncome',
  OnlineCourseOnlineCourseIncomeDetailId = 'onlineCourseOnlineCourseIncomeDetailId',

  // 门店管理
  StudioManagement = 'studioManagement',
  StudioManagementStudioList = 'studioManagementStudioList',
  StudioManagementStudioDetailId = 'studioManagementStudioDetailId',
  StudioManagementStaffList = 'studioManagementStaffList',

  // 班级管理
  ClassManagement = 'classManagement',
  ClassManagementClassList = 'classManagementClassList',
  ClassManagementClassDetailId = 'classManagementClassDetailId',

  // 师资管理
  TeacherManagement = 'teacherManagement',
  TeacherManagementTeacherList = 'teacherManagementTeacherList',
  TeacherManagementTeacherDetailId = 'teacherManagementTeacherDetailId',
  TeacherManagementTeacherSettlementClassTime = 'teacherManagementTeacherSettlementClassTime',

  // 营销中心
  MarketingCenter = 'marketingCenter',
  MarketingCenterMiniProgramResource = 'marketingCenterMiniProgramResource',
  MarketingCenterMemberCardCashCoupon = 'marketingCenterMemberCardCashCoupon', // 会员卡代金券
  MarketingCenterMarketingList = 'marketingCenterMarketingList',
  MarketingCenterMarketingDetailId = 'marketingCenterMarketingDetailId',
  MarketingCenterUserDataReport = 'marketingCenterUserDataReport',
  MarketingCenterBeginnerPlan = 'marketingCenterBeginnerPlan',
  MarketingCenterBeginnerPlanEdit = 'marketingCenterBeginnerPlanEdit',
  MarketingCenterBeginnerPlanUserData = 'marketingCenterBeginnerPlanUserData',
  MarketingCenterReferral = 'marketingCenterReferral',
  MarketingCenterReferralData = 'marketingCenterReferralData',
  MarketingCenterBisaiyiEvent = 'marketingCenterBisaiyiEvent',
  MarketingCenterAiPoster = 'marketingCenterAiPoster',
  MarketingCenterDancerIdCard = 'marketingCenterDancerIdCard',

  // 财务管理
  FinanceManagement = 'financeManagement',
  FinanceManagementCashFlowIncomeList = 'financeManagementCashFlowIncomeList',
  FinanceManagementCashFlowIncomeDetailId = 'financeManagementCashFlowIncomeDetailId',
  FinanceManagementConfirmIncomeList = 'financeManagementConfirmIncomeList',
  FinanceManagementConfirmIncomeDetailId = 'financeManagementConfirmIncomeDetailId',
  FinanceManagementPaymentAccount = 'financeManagementPaymentAccount',
  FinanceManagementPaymentAccountAuthId = 'financeManagementPaymentAccountAuthId',
  FinanceManagementWithdraw = 'financeManagementWithdraw',
  FinanceManagementOrderList = 'financeManagementOrderList',
  FinanceManagementOrderDetailId = 'financeManagementOrderDetailId',

  // 商户设置
  MerchantSettings = 'merchantSettings',
  MerchantSettingsMiniProgram = 'merchantSettingsMiniProgram',
  MerchantSettingsBasicSettings = 'merchantSettingsBasicSettings',
  MerchantSettingsVideoStorage = 'merchantSettingsVideoStorage',
  MerchantSettingsServiceNotifications = 'merchantSettingsServiceNotifications',
}

/**
 * 功能操作权限
 */
export enum ACTION_CONTROL {
  // 线索中心
  ClueEntry = 'action_clueEntry', // 线索录入
  AssignClue = 'action_assignClue', // 分配线索
  ClueDoneEntry = 'action_clueDoneEntry', // 线索录入
  AssignDoneClue = 'action_assignDoneClue', // 分配线索

  // 线索详情
  EditClue = 'action_editClue', // 编辑线索、修改关联用户
  MergeClue = 'action_mergeClue', // 合并线索

  // 卡种管理
  EditMemberCard = 'action_editMemberCard', // 会员卡新建、编辑、上下线
  EditContract = 'action_editContract', // 电子合同新建、编辑、删除

  // 会员看版
  MemberDataImport = 'action_memberDataImport', // 会员数据导入
  MemberCardBatchExtend = 'action_memberCardBatchExtend', // 会员卡批量延期

  // 会员详情
  ModifyOwner = 'action_modifyOwner', // 修改负责人
  EditMemberInfo = 'action_editMemberInfo', // 编辑会员信息、换绑手机号
  CreateOrder = 'action_createOrder', // 在线支付开卡
  QuickOpenCard = 'action_quickOpenCard', // 快捷开卡(线下收款开卡)
  // OperateVoucher = 'action_operateVoucher', // 发放/失效课次券
  ManageMemberCard = 'action_manageMemberCard', // 停卡、转卡、修改开卡负责人
  ModifyMemberCardValidity = 'action_modifyMemberCardValidity', // 修改会员卡有效期、恢复过期卡
  VoidRefundMemberCard = 'action_voidRefundMemberCard', // 作废、退卡退款

  // 课程管理
  Schedule = 'action_schedule', // 新建排课、复制课表、发布课程
  EditCourse = 'action_editCourse', // 编辑课程、编辑介绍
  CancelCourse = 'action_cancelCourse', // 取消课程
  CourseSettlement = 'action_courseSettlement', // 课程结算
  DelegateCourse = 'action_delegateCourse', // 代约课
  CancelUserAppointment = 'action_cancelUserAppointment', // 取消用户预约、代签到
  UploadClassVideo = 'action_uploadClassVideo', // 上传课堂视频
  AdjustPayNum = 'action_adjustPayNum', // 调整扣减课次
  // BatchSendCoupon = 'action_batchSendCoupon', // 批量发券
  ClassCourseAttendance = 'action_classCourseAttendance', // 班级课程 - 考勤

  // 班级管理
  CreateClass = 'action_createClass', // 新建班级 编辑班级
  ClassEnd = 'action_classEnd', // 班级结课、删除班级
  ManageStudent = 'action_manageStudent', // 学员管理（添加、移出、换班）
  ScheduleClass = 'action_scheduleClass', // 班级排课

  // 优惠券管理
  OperateCoupon = 'action_operateCoupon', // 优惠券发放、失效

  // 营销中心
  EditClassSessionVoucher = 'action_editClassSessionVoucher', // 课次券新建、编辑、下线
  InvalidateClassSessionVoucher = 'action_invalidateClassSessionVoucher', // 课次券发失效
  EditBeginnerPlan = 'action_editBeginnerPlan', // 新手计划新建、编辑、上下线
  EditReferral = 'action_editReferral', // 转介绍新建、编辑、上下线
  EditMemberCardCashCoupon = 'action_editMemberCardCashCoupon', // 代金券新建、编辑、下线
  OperateMemberCardCashCoupon = 'action_operateMemberCardCashCoupon', // 代金券发放、失效
  ManageDancerIdCard = 'action_manageDancerIdCard', // 舞者成就卡开通、购买、修改规则、关闭

  // 线上课
  OnlineCourseSetPrice = 'action_onlineCourseSetPrice', // 设置会员卡价格
  OnlineCourseDelegate = 'action_onlineCourseDelegate', // 代约课

  // 师资管理
  TeacherSetReceiveLimit = 'action_teacherSetReceiveLimit', // 课时费设置
  OnlineCourseAdjustPayNum = 'action_onlineCourseAdjustPayNum', // 调整扣减课次

  // 经营分析
  EditPerformance = 'action_editPerformance', // 业绩修改
}
